import EmployeeInfo from './EmployeeInfo'
import EmployeeManage from './EmployeeManage'
import EmployeeManageGA from './EmployeeManageGA'
import EmployeeFamily from './EmployeeFamily'
import EmployeeEducation from './EmployeeEducation'
import EmployeeExperience from './EmployeeExperience'
import EmployeeCer from './EmployeeCer'
import EmployeeLanguageSkill from './EmployeeLanguageSkill'
import EmployeeUploadFile from './EmployeeUploadFile'
import EmployeePrivacy from './EmployeePrivacy'
import EmployeeAddress from './EmployeeAddress'
import EmployeeSso from './EmployeeSso'
import EmployeeComputerSkill from './EmployeeComputerSkill'
import EmployeeJobExperience from './EmployeeJobExperience'
import EmployeePositionTransfer from './EmployeePositionTransfer'
import EmployeeInfoIssue from './EmployeeInfoIssue'
import EmployeeInfoMerge from './EmployeeInfoMerge'
import EmployeeCheckList from './EmployeeCheckList'
import EmployeeIssueInfomation from './EmployeeIssueInfomation'
import EmployeeProbation from './EmployeeProbation'
import EmployeeResign from './EmployeeResign'
import EmployeeCerLevel from './EmployeeCerLevel'
import Export from './Export'
import EmployeeApprentice from './EmployeeApprentice'
import EmployeeManageImage from './EmployeeManageImage'
// import EmployeeImport from './EmployeeImport'

export default {
  EmployeeIssueInfomation,
  EmployeeCheckList,
  EmployeeManage,
  EmployeeManageGA,
  EmployeeInfo,
  EmployeeAddress,
  EmployeeFamily,
  EmployeeEducation,
  EmployeeExperience,
  EmployeeCer,
  EmployeeLanguageSkill,
  EmployeeUploadFile,
  EmployeePrivacy,
  EmployeeSso,
  EmployeeComputerSkill,
  EmployeeJobExperience,
  EmployeePositionTransfer,
  EmployeeInfoIssue,
  EmployeeInfoMerge,
  EmployeeProbation,
  EmployeeResign,
  EmployeeCerLevel,
  Export,
  EmployeeApprentice,
  EmployeeManageImage
  // EmployeeImport
}



// WEBPACK FOOTER //
// ./src/components/HRM/Employee/index.js